import { render, staticRenderFns } from "./CurrencyControl.vue?vue&type=template&id=48cc5b47&"
import script from "./CurrencyControl.vue?vue&type=script&lang=js&"
export * from "./CurrencyControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports